<template>
  <div class="content-custom-pj">
    <div>{{ this.chkUserModulRightCheck() }}</div>
    <div v-if="!ModulRightCheck">
      <b-alert show variant="danger">ไม่มีสิทธิเข้าใช้งาน Patient EMR</b-alert>
    </div>
    <div v-if="ModulRightCheck" v-show="ModulRightCheck">
      <h4>
        <v-icon name="user" class="icon-custom1"></v-icon> Patient EMR
        {{ this.routeUrlChang }} {{ this.EmrCheckLogin }}
      </h4>

      <b-navbar
        toggleable="lg"
        type="dark"
        variant="dark"
        v-bind:class="{
          'navbar-color': this.HGscrollY,
          'navbar-default': !this.HGscrollY,
        }"
        class="border-radius visit-list-navbar-custom"
        style="opacity: 1;"
      >
        <b-navbar-nav>
          <b-form @submit="PatientSearch" id="FmPatientSearch">
            <b-input-group size="sm">
              <b-input-group-text slot="prepend" size="sm" class="badge-info"
                >HN</b-input-group-text
              >
              <b-form-input
                size="sm"
                type="number"
                maxlength="9"
                id="hn"
                name="hn"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0,this.maxLength);"
                v-model="form.hn"
                style="width:110px;"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  size="sm"
                  id="SearchBT"
                  type="submit"
                  variant="success"
                >
                  <v-icon name="search" class="icon-custom1"></v-icon>
                </b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button
                  size="sm"
                  id="t1"
                  type="button"
                  variant="dark"
                  disabled
                >
                </b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button
                  size="sm"
                  id="ActiveBT"
                  type="button"
                  variant="danger"
                  @click="this.PatientActive"
                >
                  <v-icon name="user-check" class="icon-custom1"></v-icon>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </b-navbar-nav>

        <b-navbar-toggle
          target="nav-collapse-visit"
          class="toggle-custom"
        ></b-navbar-toggle>

        <b-collapse
          id="nav-collapse-visit"
          v-model="showCollapse"
          class="scrollbar"
          is-nav
          v-bind:style="{
            'max-height': `${this.$store.get('systems@PageHeight') - 120}px`,
          }"
        >
          <div class="visit-list-navbar">
            <EmrVisitData
              v-if="
                this.$store.get('systems@PageWidth') <= 991 &&
                  !this.checHN &&
                  this.$store.get('systems@ApiKey') != '' &&
                  this.VisitDetailDataLoadSTD &&
                  this.ErProgressNoteLoadSTD &&
                  this.FastTrackStemiLoadSTD &&
                  this.AnestheticNoteLoadSTD &&
                  this.PtNoteLoadSTD &&
                  this.XrayHeadLoadSTD &&
                  this.LabHeadLoadSTD &&
                  this.AdmitRightsCenterLoadSTD &&
                  this.EarHearingDetailLoadSTD &&
                  this.DisabilityLoadSTD &&
                  this.ConsultLoadSTD &&
                  this.OpdHistoryPrintDataLoadSTD &&
                  this.BTRloadStatus
              "
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-bind:pt-historyprint="this.$store.get('systems@ptHistoryPrint')"
            ></EmrVisitData>
          </div>
        </b-collapse>
      </b-navbar>
    </div>

    <div
      class="text-align-left"
      style="margin-top: 10px;"
      v-if="
        this.PatientDataSTD && !this.checHN && this.$store.get('systems@ApiKey')
      "
    >
      <b-row>
        <b-col lg="9">
          <EmrPaientData
            v-bind:my-vn="this.$store.get('systems@vnEMR')"
            v-bind:my-hn="this.$store.get('systems@hnEMR')"
            v-if="
              this.PatientDataSTD &&
                this.PatientDataLoadSTD &&
                this.PatientImageLoadSTD &&
                this.BloodGrouploadStatus
            "
          ></EmrPaientData>

          <div class="emr-show-data">
            <EmrOpdHistoryPrint
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-bind:pt-historyprint="this.$store.get('systems@ptHistoryPrint')"
              v-if="this.PatientDataSTD"
            ></EmrOpdHistoryPrint>

            <EmrDocumentScan
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-if="this.DocumentScanLoadSTD"
            ></EmrDocumentScan>

            <EmrVisitDetailData
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-if="this.VisitDetailDataLoadSTD"
            ></EmrVisitDetailData>

            <EmrScreeningOPD
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-if="this.VitalSignLoadSTD"
            ></EmrScreeningOPD>

            <b-alert
              show
              variant="dark"
              class="margin-bottom font12px d-print-none"
              v-if="this.VisitDetailDataLoadSTD"
            >
              <h6>Add other Note</h6>

              <b-row>
                <b-col class="mr-auto">
                  <b-img
                    thumbnail
                    rounded="circle"
                    alt="ER / OPD Progress Note"
                    title="ER / OPD Progress Note"
                    width="50"
                    class="icon-css cursor-pointer margin-right8px"
                    style="background-color:#ffffff;padding:2px;"
                    v-bind:src="imgMedicalIcon"
                    v-b-modal.bv-modal-progressnote
                  ></b-img>

                  <b-img
                    thumbnail
                    rounded="circle"
                    alt="Fast Track STEMI"
                    title="Fast Track STEMI"
                    width="50"
                    class="icon-css cursor-pointer margin-right8px"
                    style="background-color:#ffffff;padding:2px;"
                    v-bind:src="imgFastTrackSTEMIIcon"
                    v-b-modal.bv-modal-fast-track-stemi
                  ></b-img>

                  <b-img
                    thumbnail
                    rounded="circle"
                    alt="Anaesthetic Note"
                    title="Anaesthetic Note"
                    width="50"
                    class="icon-css cursor-pointer margin-right8px"
                    style="background-color:#ffffff;padding:2px;"
                    v-bind:src="imgAnaestheticIcon"
                    v-b-modal.bv-modal-anesthetic-note
                  ></b-img>

                  <b-img
                    thumbnail
                    rounded="circle"
                    alt="PT (กายภาพบำบัด)"
                    title="PT (กายภาพบำบัด)"
                    width="50"
                    class="icon-css cursor-pointer margin-right8px"
                    style="background-color:#ffffff;padding:2px;"
                    v-bind:src="imgPhysiotherapyIcon"
                    v-b-modal.bv-modal-pt-note
                  ></b-img>

                  <b-img
                    thumbnail
                    rounded="circle"
                    alt="เพิ่มรายงานปฏิกิริยาจากการรับเลือด (BTR)"
                    title="เพิ่มรายงานปฏิกิริยาจากการรับเลือด (BTR)"
                    width="50"
                    class="icon-css cursor-pointer margin-right8px"
                    style="background-color:#ffffff;padding:2px;"
                    v-bind:src="imgBTRAddIcon"
                    @click="addBTR()"
                  ></b-img>
                </b-col>
              </b-row>
            </b-alert>

            <EmrReportBTR
              v-if="
                this.VisitDetailDataLoadSTD && this.$store.get('systems@vnEMR')
              "
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-bind:my-an="this.$store.get('systems@anEMR')"
            ></EmrReportBTR>

            <EmrOpdErProgressNote
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-if="this.ErProgressNoteLoadSTD && this.FastTrackStemiLoadSTD"
            ></EmrOpdErProgressNote>

            <EmrOpdAnestheticNote
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-if="this.AnestheticNoteLoadSTD"
            ></EmrOpdAnestheticNote>

            <EmrOpdPtNote
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-if="this.PtNoteLoadSTD"
            ></EmrOpdPtNote>

            <EmrTreatmentOPD
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-if="this.PtDxDataLoadSTD"
            ></EmrTreatmentOPD>
            <EmrXrayOPD
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-if="this.XrayHeadLoadSTD"
            ></EmrXrayOPD>

            <EmrDrugNoneDrugOPD
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-if="this.$store.get('systems@vnEMR') && this.PatientDataSTD"
            ></EmrDrugNoneDrugOPD>

            <EmrDrugNoneDrugTrx
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-bind:my-an="this.$store.get('systems@anEMR')"
              v-if="this.$store.get('systems@anEMR') && this.PatientDataSTD"
            ></EmrDrugNoneDrugTrx>

            <EmrLabOPD
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-if="this.LabHeadLoadSTD"
            ></EmrLabOPD>
          </div>
        </b-col>
        <b-col lg="3">
          <div class="disable-list-navbar">
            <EmrVisitData
              v-if="
                this.$store.get('systems@PageWidth') > 991 &&
                  this.$store.get('systems@ApiKey') != '' &&
                  this.VisitDetailDataLoadSTD &&
                  this.ErProgressNoteLoadSTD &&
                  this.FastTrackStemiLoadSTD &&
                  this.AnestheticNoteLoadSTD &&
                  this.PtNoteLoadSTD &&
                  this.XrayHeadLoadSTD &&
                  this.LabHeadLoadSTD &&
                  this.AdmitRightsCenterLoadSTD &&
                  this.EarHearingDetailLoadSTD &&
                  this.DisabilityLoadSTD &&
                  this.ConsultLoadSTD &&
                  this.OpdHistoryPrintDataLoadSTD &&
                  this.BTRloadStatus
              "
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-bind:pt-historyprint="this.$store.get('systems@ptHistoryPrint')"
            ></EmrVisitData>
          </div>
        </b-col>
      </b-row>
    </div>

    <div style="margin-top: 10px;">
      <b-row>
        <b-col lg="12">
          <b-alert show variant="danger" v-if="!this.ptCk && this.checHN"
            >Patient Not found</b-alert
          >
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import PatientData from "@/models/patientEMRs/PatientData";
import PatientDentalAreaData from "@/models/patientEMRs/PatientDentalAreaData";
import PatientDentalData from "@/models/patientEMRs/PatientDentalData";
import PatientDentalVisitData from "@/models/patientEMRs/PatientDentalVisitData";
import PatientEmrPtDxData from "@/models/patientEMRs/PatientEmrPtDxData";
import PatientEmrPtIndicator from "@/models/patientEMRs/PatientEmrPtIndicator";
import PatientEmrPtTemplate from "@/models/patientEMRs/PatientEmrPtTemplate";
import PatientEmrTemplate from "@/models/patientEMRs/PatientEmrTemplate";
import PatientImage from "@/models/patientEMRs/PatientImage";
import PatientLabHead from "@/models/patientEMRs/PatientLabHead";
import PatientOpdAnestheticNote from "@/models/patientEMRs/PatientOpdAnestheticNote";
import PatientOpdErProgressNote from "@/models/patientEMRs/PatientOpdErProgressNote";
import PatientOpdFastTrackStemi from "@/models/patientEMRs/PatientOpdFastTrackStemi";
import PatientPhamarcyADR from "@/models/patientEMRs/PatientPhamarcyADR";
import PatientPhamarcyCounseling from "@/models/patientEMRs/PatientPhamarcyCounseling";
import PatientScreening from "@/models/patientEMRs/PatientScreening";
import PatientVisit from "@/models/patientEMRs/PatientVisit";
import PatientWebbaseUrl from "@/models/patientEMRs/PatientWebbaseUrl";
import PatientXrayHead from "@/models/patientEMRs/PatientXrayHead";
import store from "@/store/store";
import feather from "vue-icon";
import { Component, Vue } from "vue-property-decorator";

import PatientAdmitDischargeStatus from "@/models/patientEMRs/PatientAdmitDischargeStatus";
import PatientAdmitDischargeType from "@/models/patientEMRs/PatientAdmitDischargeType";

import EmrDocumentScan from "@/components/PatientEMR/EmrDocumentScan";
import EmrDrugNoneDrugOPD from "@/components/PatientEMR/EmrDrugNoneDrugOPD";
import EmrDrugNoneDrugTrx from "@/components/PatientEMR/EmrDrugNoneDrugTrx";
import EmrLabOPD from "@/components/PatientEMR/EmrLabOPD";
import EmrOpdAnestheticNote from "@/components/PatientEMR/EmrOpdAnestheticNote";
import EmrOpdErProgressNote from "@/components/PatientEMR/EmrOpdErProgressNote";
import EmrOpdHistoryPrint from "@/components/PatientEMR/EmrOpdHistoryPrint";
import EmrOpdPtNote from "@/components/PatientEMR/EmrOpdPtNote";
import EmrPaientData from "@/components/PatientEMR/EmrPaientData";
import EmrScreeningOPD from "@/components/PatientEMR/EmrScreeningOPD";
import EmrTreatmentOPD from "@/components/PatientEMR/EmrTreatmentOPD";
import EmrVisitData from "@/components/PatientEMR/EmrVisitData";
import EmrVisitDetailData from "@/components/PatientEMR/EmrVisitDetailData";
import EmrXrayOPD from "@/components/PatientEMR/EmrXrayOPD";

import DocumentScan from "@/models/patientEMRs/DocumentScan";
import PatientAdmitRightsCenterChoice from "@/models/patientEMRs/PatientAdmitRightsCenterChoice";
import PatientAdmitRightsCenterChoiceL1 from "@/models/patientEMRs/PatientAdmitRightsCenterChoiceL1";
import PatientAdmitRightsCenterChoiceL2 from "@/models/patientEMRs/PatientAdmitRightsCenterChoiceL2";
import PatientAppointmentData from "@/models/patientEMRs/PatientAppointmentData";
import PatientEmrPtData from "@/models/patientEMRs/PatientEmrPtData";

import pjFunctions from "@/functions/pjFunctions";
import thaiDatetime from "@/functions/thaiDatetime";
import PatientAdmitRightsCenterHead from "@/models/patientEMRs/PatientAdmitRightsCenterHead";

import EmrReportBTR from "@/components/PatientEMR/EmrReportBTR";
import DrugNarcotic from "@/models/patientEMRs/DrugNarcotic";
import LabBtrChoice from "@/models/patientEMRs/LabBtrChoice";
import LabBtrData from "@/models/patientEMRs/LabBtrData";
import PatientEmrConsultData from "@/models/patientEMRs/PatientEmrConsultData";
import PatientEmrDisabilityData from "@/models/patientEMRs/PatientEmrDisabilityData";
import PatientEmrEarHearingDetail from "@/models/patientEMRs/PatientEmrEarHearingDetail";
import PatientLabBloodGroup from "@/models/patientEMRs/PatientLabBloodGroup";
import PatientMDRData from "@/models/patientEMRs/PatientMDRData";
import PatientOpdHistoryPrintData from "@/models/patientEMRs/PatientOpdHistoryPrintData";

const MedicalIcon = require("@/images/OPD-Note27-512.png");
const AnaestheticIcon = require("@/images/Medical-33-512.png");
const FastTrackSTEMIIcon = require("@/images/Medical-06-512.png");
const PhysiotherapyIcon = require("@/images/pt.png");
const BTRAddIcon = require("@/images/blood_drop_type_b_medical-512.png");

Vue.use(feather, "v-icon");

@Component({
  components: {
    PatientData,
    PatientImage,
    PatientVisit,
    PatientLabHead,
    EmrPaientData,
    EmrVisitData,
    PatientXrayHead,
    EmrLabOPD,
    EmrXrayOPD,
    EmrScreeningOPD,
    EmrTreatmentOPD,
    EmrDrugNoneDrugOPD,
    EmrDrugNoneDrugTrx,
    EmrVisitDetailData,
    PatientAppointmentData,
    DocumentScan,
    EmrDocumentScan,
    EmrOpdErProgressNote,
    PatientEmrTemplate,
    EmrOpdAnestheticNote,
    PatientOpdFastTrackStemi,
    PatientEmrPtTemplate,
    PatientEmrPtIndicator,
    EmrOpdPtNote,
    PatientEmrPtData,
    PatientEmrPtDxData,
    PatientDentalData,
    PatientDentalAreaData,
    PatientDentalVisitData,
    PatientScreening,
    PatientPhamarcyADR,
    PatientWebbaseUrl,
    PatientPhamarcyCounseling,
    PatientAdmitDischargeStatus,
    PatientAdmitDischargeType,
    PatientAdmitRightsCenterChoice,
    PatientAdmitRightsCenterChoiceL1,
    PatientAdmitRightsCenterChoiceL2,
    PatientAdmitRightsCenterHead,
    thaiDatetimeFc: null,
    pjFunctionsFc: null,
    PatientEmrEarHearingDetail,
    PatientEmrDisabilityData,
    DrugNarcotic,
    PatientEmrConsultData,
    PatientMDRData,
    PatientOpdHistoryPrintData,
    EmrOpdHistoryPrint,
    LabBtrChoice,
    LabBtrData,
    PatientLabBloodGroup,
    EmrReportBTR,
  },
  data() {
    return {
      imgMedicalIcon: MedicalIcon,
      imgAnaestheticIcon: AnaestheticIcon,
      imgFastTrackSTEMIIcon: FastTrackSTEMIIcon,
      imgPhysiotherapyIcon: PhysiotherapyIcon,
      imgBTRAddIcon: BTRAddIcon,
      showCollapse: false,
      CheckLogin: false,
      ModulRightCheck: false,
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 100,
        height: 120,
        class: "m1",
      },
      baseClass: "v-icon",
      routerPath: "",
      form: {
        hn: "",
      },
      isShow: false,
      HGscrollY: false,
      ptCk: false,
      LoadStd: false,
      ptHN: "",
      ptVN: "",
      RptHN: "",
      RptVN: "",
      UserLogin: "",
      LabHeadLoadSTD: false,
      XrayHeadLoadSTD: false,
      PtNoteLoadSTD: false,
      AppointmentDataLoadSTD: false,
      DocumentScanLoadSTD: false,
      ErProgressNoteLoadSTD: false,
      AnestheticNoteLoadSTD: false,
      FastTrackStemiLoadSTD: false,
      PtDxDataLoadSTD: false,
      VisitDetailDataLoadSTD: false,
      VitalSignLoadSTD: false,
      PatientDataSTD: false,
      EarHearingDetailLoadSTD: false,
      DisabilityLoadSTD: false,
      ConsultLoadSTD: false,
      AdmitRightsCenterLoadSTD: false,
      navHN: "",
      checHN: false,
      vnS: "",
      LoadVN: "",
      PatientMDRDataSTD: false,
      OpdHistoryPrintDataLoadSTD: false,
      PatientDataLoadSTD: false,
      PatientImageLoadSTD: false,
      BTRloadStatus: false,
      BloodGrouploadStatus: false,
    };
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;

    this.RptHN = this.$route.params.hn;
    this.RptVN = this.$route.params.vn;

    this.navHN = this.$store.get("systems@SearchPTid");

    this.chkUserModulRightCheck();
  },
  mounted() {
    if (
      this.$route.params.hn &&
      this.$route.params.vn &&
      this.$store.get("systems@ApiKey")
    ) {
      // console.log('ppppppppp',this.$route.params.hn, this.$route.params.vn, this.$store.get("systems@ApiKey"))
      // this.LoadVN = "";
      // this.form.hn = this.$route.params.hn;
      store.set("systems@SearchPT", true);
      store.set("systems@SearchPTid", this.$route.params.hn);
      this.routeUrlChang;
    }
    this.navHN = this.$store.get("systems@SearchPTid");
  },
  watch: {
    $route(to, from) {
      if (this.$route.params.hn != "" && this.$route.params.hn != null) {
        store.set("systems@hnEMR", this.$route.params.hn);
        store.set("systems@vnEMR", this.$route.params.vn);

        setTimeout(() => {
          store.set("systems@SpinnersShow", false);
        }, 1000);
      } else {
        this.ptHN = "";
        this.ptVN = "";
      }
    },
    navHN: function() {},
    ptHN: function() {},
    ptVN: function() {
      // && this.$route.params.vn != this.ptVN

      if (
        this.$route.params.hn != "" &&
        this.$route.params.vn != "" &&
        this.$route.params.vn != this.ptVN
      ) {
        this.loadPtData(this.ptHN, this.ptVN);
      }
    },
    RptHN: function() {
      if (this.$route.params.hn != "") {
        this.form.hn = this.$route.params.hn;
        // this.loadPtData(this.$route.params.hn, "");
        this.ptHN = this.$route.params.hn;
      }
    },
    RptVN: function() {
      if (this.$route.params.hn != "") {
        this.form.hn = this.$route.params.hn;
        // this.loadPtData(this.$route.params.hn, this.$route.params.vn)
        this.ptHN = this.$route.params.hn;
      }

      if (this.$route.params.vn != "") {
        this.ptVN = this.$route.params.vn;
      }
    },
  },
  computed: {
    routeUrlChang() {
      if (
        this.$store.get("systems@ApiKey") == "" &&
        this.$store.get("systems@ApiKey") == null
      ) {
        this.RptHN = "";
        this.RptVN = "";
      } else {
        if (this.$store.get("systems@SearchPT")) {
          let vv = "";

          store.set("systems@SearchPT", false);
          this.RptHN = this.$store.get("systems@SearchPTid");
          this.RptVN = "";

          this.ptHN = this.$store.get("systems@SearchPTid");
          store.set("systems@hnEMR", this.$store.get("systems@SearchPTid"));
          this.form.hn = this.$store.get("systems@SearchPTid");

          if (
            this.$route.params.vn != "" &&
            this.$route.params.vn != null &&
            this.$route.params.vn != "undefined" &&
            this.$route.params.vn != undefined
          ) {
            vv = this.$route.params.vn;
          }

          this.loadPtData(this.$store.get("systems@SearchPTid"), vv);
        } else {
          this.RptHN = this.$route.params.hn;
          this.RptVN = this.$route.params.vn;
        }
      }
    },
    EmrCheckLogin() {
      if (
        this.$store.get("systems@ApiKey") != "" &&
        this.$store.get("systems@ApiKey") != null &&
        !this.CheckLogin
      ) {
        this.loadDataOnCreate();
        this.CheckLogin = true;
      }
    },
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    chkUserModulRightCheck() {
      if (this.$store.get("systems@LoginStatus")) {
        if (
          this.pjFunctionsFc.UserModulRightCheck(
            this.$store.get("systems@LoginData").accessright,
            "Admin"
          ) ||
          this.pjFunctionsFc.UserHOSxPRightCheck(
            this.$store.get("systems@LoginData").hos_accessright,
            "ADMIN"
          ) ||
          this.pjFunctionsFc.UserHOSxPRightCheck(
            this.$store.get("systems@LoginData").hos_accessright,
            "EMR_VIEW"
          ) ||
          this.pjFunctionsFc.UserHOSxPRightCheck(
            this.$store.get("systems@LoginData").hos_accessright,
            "View_EMR"
          )
        ) {
          this.ModulRightCheck = true;
        } else {
          this.ModulRightCheck = false;
        }
      } else {
        this.ModulRightCheck = false;
      }
    },
    show(group, type = "", title = "", text = "") {
      //const text = `
      //  This is notification text!
      //  <br>
      //  Date: ${new Date()}
      // `
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random(),
        },
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    PatientSearch(e) {
      e.preventDefault();

      if (
        this.form.hn != "" &&
        this.form.hn != "undefined" &&
        this.form.hn != undefined &&
        this.form.hn != null &&
        (this.form.hn.length == 9 || this.form.hn.length == 13)
      ) {
        this.ptHN = "";
        this.isShow = false;
        this.LoadStd = false;
        this.checHN = false;
        store.set("systems@vnEMR", "");
        store.set("systems@hnEMR", "");

        if (this.form.hn != this.$route.params.hn) {
          // this.$router.push({ path: "/PatientEMR/" + this.form.hn });
        }

        let currentObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "PatientData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: this.form.hn,
          })
          .then(function(response) {
            currentObj.output = response.data;
            if (currentObj.output.status === true) {
              //currentObj.$router.push({
              //path: "/PatientEMR/" + currentObj.output.result.hn
              //});

              currentObj.ptCk = true;

              store.set("systems@hnEMR", currentObj.output.result.hn);
              currentObj.loadPtData(currentObj.output.result.hn, "");
            } else {
              currentObj.ptCk = false;
              currentObj.checHN = true;

              currentObj.show(
                "notifi-main-top-right",
                "warn",
                "Invalid HN or CID ",
                "ไม่พบ HN หรือ CID ที่คุณต้องการค้นหา -_- ! <br>Date : " +
                  currentObj.thaiDatetimeFc.ThaiDateTime(
                    currentObj.thaiDatetimeFc.DateTimeNow()
                  )
              );
            }
          })
          .catch(function(error) {
            currentObj.output = error;
            currentObj.show(
              "notifi-main-top-right",
              "error",
              "Search Patient Error",
              currentObj.output +
                " -_- ! <br>Date : " +
                currentObj.thaiDatetimeFc.ThaiDateTime(
                  currentObj.thaiDatetimeFc.DateTimeNow()
                )
            );
          });
      } else {
        alert("HN ไม่ถูกต้อง");
      }
    },

    loadPtData(hn, vn) {
      /*
            if (this.$store.get("systems@PageWidth") <= 991) {
                this.$root.$emit("bv::toggle::collapse", "nav-collapse-visit");
            }
*/

      store.set("systems@SpinnersShow", true);

      this.showCollapse = false;

      this.LabHeadLoadSTD = false;
      this.XrayHeadLoadSTD = false;
      this.PtNoteLoadSTD = false;
      this.AppointmentDataLoadSTD = false;
      this.DocumentScanLoadSTD = false;
      this.ErProgressNoteLoadSTD = false;
      this.AnestheticNoteLoadSTD = false;
      this.FastTrackStemiLoadSTD = false;
      this.PtDxDataLoadSTD = false;
      this.VisitDetailDataLoadSTD = false;
      this.VitalSignLoadSTD = false;
      this.PatientDataSTD = false;
      this.ConsultLoadSTD = false;
      this.AdmitRightsCenterLoadSTD = false;
      this.OpdHistoryPrintDataLoadSTD = false;
      this.PatientDataLoadSTD = false;
      this.PatientImageLoadSTD = false;
      this.BTRloadStatus = false;
      this.EarHearingDetailLoadSTD = false;
      this.DisabilityLoadSTD = false;
      this.BloodGrouploadStatus = false;

      let currentObj2 = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "PatientImage", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          currentObj2.output = response.data;
          if (currentObj2.output.status === true) {
            currentObj.ptHN = currentObj2.output.result.hn;

            PatientImage.insertOrUpdate({
              data: {
                id: currentObj2.output.result.hn,
                datas: currentObj2.output.result,
              },
            });
          }
        })
        .catch(function(error) {
          currentObj2.output = error;
          console.log("PatientImage : " + currentObj2.output);
        })
        .finally(function() {
          currentObj3.getPatientMDRData(hn);
          currentObj3.PatientImageLoadSTD = true;
        });

      this.axios
        .post(this.$store.get("systems@UrlApi") + "EmrLabBloodGroup", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          currentObj2.output = response.data;
          if (currentObj2.output.status === true) {
            currentObj.ptHN = currentObj2.output.result.hn;

            if (currentObj2.output.result.blood_group) {
              PatientLabBloodGroup.insertOrUpdate({
                data: {
                  id: hn + "blood_group",
                  items_type: "blood_group",
                  hn: currentObj2.output.result.blood_group.hn,
                  vn: currentObj2.output.result.blood_group.vn,
                  lab_items_code:
                    currentObj2.output.result.blood_group.lab_items_code,
                  lab_items_name_ref:
                    currentObj2.output.result.blood_group.lab_items_name_ref,
                  lab_order_result:
                    currentObj2.output.result.blood_group.lab_order_result,
                  datas: currentObj2.output.result.blood_group,
                },
              });
            }

            if (currentObj2.output.result.blood_rh) {
              PatientLabBloodGroup.insertOrUpdate({
                data: {
                  id: hn + "blood_rh",
                  items_type: "blood_rh",
                  hn: currentObj2.output.result.blood_rh.hn,
                  vn: currentObj2.output.result.blood_rh.vn,
                  lab_items_code:
                    currentObj2.output.result.blood_rh.lab_items_code,
                  lab_items_name_ref:
                    currentObj2.output.result.blood_rh.lab_items_name_ref,
                  lab_order_result:
                    currentObj2.output.result.blood_rh.lab_order_result,
                  datas: currentObj2.output.result.blood_rh,
                },
              });
            }
          }
        })
        .catch(function(error) {
          currentObj2.output = error;
          console.log("EmrLabBloodGroup : " + currentObj2.output);
        })
        .finally(function() {
          currentObj2.BloodGrouploadStatus = true;
        });

      let currentObj3 = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "PatientMDR", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          currentObj3.output = response.data;
          if (currentObj3.output.status === true) {
            PatientMDRData.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            console.log();
            let data = [];
            for (var val of currentObj3.output.result) {
              data.push({
                id: val.lab_order_number,
                hn: val.hn,
                datas: val,
                report_datetime: val.dd,
              });
            }

            PatientMDRData.insertOrUpdate({
              data,
            });
          }
        })
        .catch(function(error) {
          currentObj3.output = error;
          console.log("PatientMDR : " + currentObj3.output);
        })
        .finally(function() {
          currentObj3.getPatientMDRData(hn);
        });

      let currentObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "PatientData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          currentObj.output = response.data;
          if (currentObj.output.status === true) {
            PatientData.insertOrUpdate({
              data: {
                id: currentObj.output.result.hn,
                hn: currentObj.output.result.hn,
                datas: currentObj.output.result,
              },
            });

            currentObj.ptCk = true;
          } else {
            currentObj.ptCk = false;
          }
        })
        .catch(function(error) {
          currentObj.output = error;
          console.log("PatientData : " + currentObj.output);
        })
        .finally(function() {
          currentObj.PatientDataLoadSTD = true;

          if (
            vn != "undefined" &&
            vn != undefined &&
            vn != "" &&
            vn != null &&
            vn != "null"
          ) {
            currentObj.getPatientData(hn);
            currentObj.loadVisitData(hn, vn);
            currentObj.loadAllData(hn, vn);
            currentObj.loadOpdHistoryPrintData(hn, vn);
          } else {
            currentObj.getPatientData(hn);
            currentObj.loadVisitData(hn, "");
            currentObj.loadAllData(hn, "");
            currentObj.loadOpdHistoryPrintData(hn, "");
          }
        });
    },

    loadAllData(hn, vn) {
      if (this.LoadVN != vn || vn == "") {
        this.LoadVN = vn;
        // LOAD ALL VISIT DATA

        if (hn != "" && hn != null && (vn <= "" || vn <= null)) {
          this.loadLabData(hn, "");
          this.loadXrayData(hn, "");
          this.loadAppointmentData(hn, "");
          this.loadDocumentScan(hn, "");
          this.loadOpdErProgressNote(hn, "");
          this.loadOpdAnestheticNote(hn, "");
          this.loadOpdFastTrackStemi(hn, "");
          this.loadOpdPtData(hn, "");
          this.loadOpdPtDiagData(hn, "");
          this.loadDentalData(hn, "");
          this.loadDentalAreaData(hn, "");
          this.loadPhamarcyADR(hn, "");
          this.loadPhamarcyCounseling(hn, "");
          this.loadAdmitRightsCenterData(hn, "");
          this.loadEarHearingDetailData(hn, "");
          this.loadDisabilityData(hn, "");
          this.loadEmrConsultData(hn, "");
          this.loadQueryBTR(hn);
        } else {
          if (hn != "" && hn != null && vn != "" && vn != null) {
            if (this.vnS != vn) {
              this.vnS = vn;

              this.loadLabData(hn, vn);
              this.loadXrayData(hn, vn);
              this.loadAppointmentData(hn, vn);
              this.loadDocumentScan(hn, vn);
              this.loadOpdErProgressNote(hn, vn);
              this.loadOpdAnestheticNote(hn, vn);
              this.loadOpdFastTrackStemi(hn, vn);
              this.loadOpdPtData(hn, vn);
              this.loadOpdPtDiagData(hn, vn);
              this.loadDentalData(hn, vn);
              this.loadDentalAreaData(hn, vn);
              this.loadPhamarcyADR(hn, vn);
              this.loadPhamarcyCounseling(hn, vn);
              this.loadAdmitRightsCenterData(hn, vn);
              this.loadEarHearingDetailData(hn, vn);
              this.loadDisabilityData(hn, vn);
              this.loadEmrConsultData(hn, vn);
              this.loadQueryBTR(hn);
              // this.loadOpdHistoryPrintData(hn, vn);
            } else {
              store.set("systems@SpinnersShow", false);
            }
          } else {
            store.set("systems@SpinnersShow", false);
          }
        }
      } else {
        this.LoadVN = "";
        store.set("systems@SpinnersShow", false);
      }
    },

    loadVisitData(hn, vn) {
      let data = [];

      let VisitObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "VisitOPD", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          VisitObj.output = response.data;
          if (VisitObj.output.status === true) {
            PatientVisit.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            let dtID = 0;
            for (var val of VisitObj.output.result) {
              if (
                val.vstdate != "" &&
                val.vstdate != "null" &&
                val.vstdate != null &&
                val.vsttime != "" &&
                val.vsttime != "null" &&
                val.vsttime != null
              ) {
                dtID = VisitObj.thaiDatetimeFc.DateTimeId(
                  val.vstdate + " " + val.vsttime
                );
              }

              data.push({
                id: val.vn,
                hn: val.hn,
                datas: val,
                visit_orderby: dtID,
              });
            }

            PatientVisit.insertOrUpdate({
              data,
            });
          } else {
            if (VisitObj.output.ErrorMessage === "Data Not Found") {
              store.set("systems@SpinnersShow", false);
              PatientVisit.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          VisitObj.output = error;
          console.log("VisitOPD : " + VisitObj.output);
        })
        .finally(function() {
          // VisitObj.$router.push({ path: '/PatientEMR/'+VisitObj.output.result[0].hn+'/'+vn });
          if (VisitObj.output.status === true) {
            VisitObj.VisitDetailDataLoadSTD = true;
            //LOAD VisitObj.loadLabData(hn, vn);
            VisitObj.selectVN(hn, vn);
          } else {
            alert("ไม่พบ Visit ของผู้ป้วย !");
          }
        });
    },

    loadLabData(hn, vn) {
      let data = [];

      let LabHeadObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "LabHeadData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          department: "",
        })
        .then(function(response) {
          LabHeadObj.output = response.data;
          if (LabHeadObj.output.status === true) {
            PatientLabHead.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            let dtID = 0;
            for (var val of LabHeadObj.output.result) {
              if (
                val.order_date != "" &&
                val.order_date != "null" &&
                val.order_date != null &&
                val.order_time != "" &&
                val.order_time != "null" &&
                val.order_time != null
              ) {
                dtID = LabHeadObj.thaiDatetimeFc.DateTimeId(
                  val.order_date + " " + val.order_time
                );
              }

              data.push({
                id: val.lab_order_number,
                lab_order_number: val.lab_order_number,
                hn: val.hn,
                vn: val.vn,
                an: val.an,
                department: val.department,
                datas: val,
                list_orderby: dtID,
              });
            }

            PatientLabHead.insertOrUpdate({
              data,
            });
          } else {
            if (LabHeadObj.output.ErrorMessage === "Data Not Found") {
              PatientLabHead.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          LabHeadObj.output = error;
          console.log("LabHeadData : " + LabHeadObj.output);
        })
        .finally(function() {
          LabHeadObj.LabHeadLoadSTD = true;
          //LOAD LabHeadObj.loadXrayData(hn, vn);
        });
    },
    loadXrayData(hn, vn) {
      let data = [];

      let XrayHeadObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "XrayHeadData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          department: "",
        })
        .then(function(response) {
          XrayHeadObj.output = response.data;
          if (XrayHeadObj.output.status === true) {
            PatientXrayHead.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            for (var val of XrayHeadObj.output.result) {
              data.push({
                id: val.vn,
                xray_order_number: val.xray_order_number,
                hn: val.hn,
                vn: val.vn,
                an: val.an,
                department: val.department,
                datas: val,
              });
            }

            PatientXrayHead.insertOrUpdate({
              data,
            });
          } else {
            if (XrayHeadObj.output.ErrorMessage === "Data Not Found") {
              PatientXrayHead.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          XrayHeadObj.output = error;
          console.log("XrayHeadData : " + XrayHeadObj.output);
        })
        .finally(function() {
          XrayHeadObj.XrayHeadLoadSTD = true;
          //LOAD XrayHeadObj.loadAppointmentData(hn, vn);
        });
    },

    loadAppointmentData(hn, vn) {
      let data = [];

      let ScrObj1 = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "AppointmentData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          ScrObj1.output = response.data;
          if (ScrObj1.output.status === true) {
            PatientAppointmentData.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            let dtID = 0;
            for (var val of ScrObj1.output.result) {
              if (
                val.nextdate != "" &&
                val.nextdate != "null" &&
                val.nextdate != null &&
                val.nexttime != "" &&
                val.nexttime != "null" &&
                val.nexttime != null
              ) {
                dtID = ScrObj1.thaiDatetimeFc.DateTimeId(
                  val.nextdate + " " + val.nexttime
                );
              }

              data.push({
                id: val.oapp_id,
                oapp_id: val.oapp_id,
                hn: val.hn,
                vn: val.vn,
                datas: val,
                list_orderby: dtID,
              });
            }

            PatientAppointmentData.insertOrUpdate({
              data,
            });
          } else {
            if (ScrObj1.output.ErrorMessage === "Data Not Found") {
              PatientAppointmentData.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          ScrObj1.output = error;
          console.log("AppointmentData : " + ScrObj1.output);
        })
        .finally(function() {
          ScrObj1.AppointmentDataLoadSTD = true;
          //LOAD ScrObj1.loadDocumentScan(hn, vn);
        });
    },

    loadDocumentScan(hn, vn) {
      let ScrObjDc = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "DocumentScan", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          ScrObjDc.output = response.data;
          if (ScrObjDc.output.status === true) {
            DocumentScan.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            DocumentScan.insertOrUpdate({
              data: {
                id: ScrObjDc.output.result.hn,
                hn: ScrObjDc.output.result.hn,
                documentGroups: ScrObjDc.output.result.documentScans,
                documentScans: "",
                documentLocation: ScrObjDc.output.result.documentLocation,
              },
            });
          } else {
            if (ScrObjDc.output.ErrorMessage === "Data Not Found") {
              DocumentScan.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          ScrObjDc.output = error;
          console.log("DocumentScan : " + ScrObjDc.output);
        })
        .finally(function() {
          ScrObjDc.DocumentScanLoadSTD = true;
          //LOAD ScrObjDc.loadOpdErProgressNote(hn, vn);
        });
    },

    loadOpdErProgressNote(hn, vn) {
      let data = [];

      // #### OpdErProgressNote Load ####
      let OpdErProgressNoteObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "OpdErProgressNote", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          OpdErProgressNoteObj.output = response.data;
          if (OpdErProgressNoteObj.output.status === true) {
            PatientOpdErProgressNote.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            for (var val of OpdErProgressNoteObj.output.result) {
              data.push({
                id: val.vn + val.loginname,
                loginname: val.loginname,
                vn: val.vn,
                hn: val.hn,
                datas: val,
              });
            }

            PatientOpdErProgressNote.insertOrUpdate({
              data,
            });
          } else {
            if (OpdErProgressNoteObj.output.ErrorMessage === "Data Not Found") {
              PatientOpdErProgressNote.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          OpdErProgressNoteObj.output = error;
          console.log("OpdErProgressNote : " + OpdErProgressNoteObj.output);
        })
        .finally(function() {
          OpdErProgressNoteObj.ErProgressNoteLoadSTD = true;
          //LOAD OpdErProgressNoteObj.loadOpdAnestheticNote(hn, vn);
        });
    },

    loadOpdAnestheticNote(hn, vn) {
      let data = [];

      // #### OpdAnestheticNote Load ####
      let AnestheticNoteObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "OpdAnestheticNote", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          AnestheticNoteObj.output = response.data;
          if (AnestheticNoteObj.output.status === true) {
            PatientOpdAnestheticNote.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            for (var val of AnestheticNoteObj.output.result) {
              data.push({
                id: val.vn + val.loginname,
                loginname: val.loginname,
                vn: val.vn,
                hn: val.hn,
                datas: val,
              });
            }

            PatientOpdAnestheticNote.insertOrUpdate({
              data,
            });
          } else {
            if (AnestheticNoteObj.output.ErrorMessage === "Data Not Found") {
              PatientOpdAnestheticNote.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          AnestheticNoteObj.output = error;
          console.log("OpdAnestheticNote : " + AnestheticNoteObj.output);
        })
        .finally(function() {
          AnestheticNoteObj.AnestheticNoteLoadSTD = true;
          //LOAD AnestheticNoteObj.loadOpdFastTrackStemi(hn, vn);
        });
    },

    loadOpdFastTrackStemi(hn, vn) {
      let data = [];

      // #### Fast Track Stemi Load ####
      let FastTrackStemiObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "OpdFastTrackStemi", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          FastTrackStemiObj.output = response.data;
          if (FastTrackStemiObj.output.status === true) {
            PatientOpdFastTrackStemi.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            for (var val of FastTrackStemiObj.output.result) {
              data.push({
                id: val.vn + val.loginname,
                loginname: val.loginname,
                vn: val.vn,
                hn: val.hn,
                datas: val,
              });
            }

            PatientOpdFastTrackStemi.insertOrUpdate({
              data,
            });
          } else {
            if (FastTrackStemiObj.output.ErrorMessage === "Data Not Found") {
              PatientOpdFastTrackStemi.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          FastTrackStemiObj.output = error;
          console.log("OpdAnestheticNote : " + FastTrackStemiObj.output);
        })
        .finally(function() {
          FastTrackStemiObj.FastTrackStemiLoadSTD = true;
          //LOAD FastTrackStemiObj.loadOpdPtData(hn, vn);
        });
    },

    loadOpdPtData(hn, vn) {
      let data = [];
      // #### PT Data Load ####
      let PtDataObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "OpdPtData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          PtDataObj.output = response.data;
          if (PtDataObj.output.status === true) {
            PatientEmrPtData.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            for (var val of PtDataObj.output.result) {
              data.push({
                id: val.vn + val.loginname,
                loginname: val.loginname,
                vn: val.vn,
                hn: val.hn,
                datas: val,
              });
            }

            PatientEmrPtData.insertOrUpdate({
              data,
            });
          } else {
            if (PtDataObj.output.ErrorMessage === "Data Not Found") {
              PatientEmrPtData.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          PtDataObj.output = error;
          console.log("OpdPtData : " + PtDataObj.output);
        })
        .finally(function() {
          PtDataObj.PTDataLoad(hn);
          PtDataObj.PtNoteLoadSTD = true;
          //LOAD PtDataObj.loadOpdPtDiagData(hn, vn);
        });
    },

    loadOpdPtDiagData(hn, vn) {
      let data = [];

      // #### PT Diag Data Load ####
      let PtDxDataObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "OpdPtDiagData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          PtDxDataObj.output = response.data;
          if (PtDxDataObj.output.status === true) {
            PatientEmrPtDxData.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            for (var val of PtDxDataObj.output.result) {
              data.push({
                id: val.pt_dx_id,
                loginname: val.loginname,
                vn: val.vn,
                hn: val.hn,
                datas: val,
              });
            }

            PatientEmrPtDxData.insertOrUpdate({
              data,
            });
          } else {
            if (PtDxDataObj.output.ErrorMessage === "Data Not Found") {
              PatientEmrPtDxData.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          PtDxDataObj.output = error;
          console.log("OpdPtDiagData : " + PtDxDataObj.output);
        })
        .finally(function() {
          PtDxDataObj.PtDxDataLoadSTD = true;
          //LOAD PtDxDataObj.loadDentalData(hn, vn);
        });
    },

    loadDentalData(hn, vn) {
      let data = [];

      // #### Dental Data Load ####
      let DentalDataObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "DentalData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          DentalDataObj.output = response.data;

          if (DentalDataObj.output.status === true) {
            PatientDentalData.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            PatientDentalVisitData.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            let result3 = null;
            for (var val of DentalDataObj.output.result) {
              data.push({
                id: val.dtmain_id,
                dtmain_id: val.dtmain_id,
                vn: val.vn,
                hn: val.hn,
                datas: val,
              });
            }

            PatientDentalData.insertOrUpdate({
              data,
            });

            data = [];

            for (var val2 of DentalDataObj.output.result) {
              result3 = data.find((finddata2) => {
                return finddata2.id == val2.hn + val2.vn;
              });

              if (!result3) {
                data.push({
                  id: val2.hn + val2.vn,
                  vn: val2.vn,
                  hn: val2.hn,
                  vstdate: val2.vstdate,
                  vsttime: val2.vsttime,
                  dentalData: [],
                });
              }
            }

            PatientDentalVisitData.insertOrUpdate({
              data,
            });
          } else {
            if (DentalDataObj.output.ErrorMessage === "Data Not Found") {
              PatientDentalData.delete({
                where(record) {
                  return record.hn == hn;
                },
              });

              PatientDentalVisitData.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          DentalDataObj.output = error;
          console.log("DentalData : " + DentalDataObj.output);
        })
        .finally(function() {
          //LOAD DentalDataObj.loadDentalAreaData(hn, vn);
        });
    },

    loadDentalAreaData(hn, vn) {
      let data = [];

      // #### Dental Area Data Load ####
      let DentalAreaDataObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "DentalAreaData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          DentalAreaDataObj.output = response.data;
          if (DentalAreaDataObj.output.status === true) {
            PatientDentalAreaData.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            for (var val of DentalAreaDataObj.output.result) {
              data.push({
                id: val.dtmain_area_id,
                dtmain_area_id: val.dtmain_area_id,
                dtmain_id: val.dtmain_id,
                vn: val.vn,
                hn: val.hn,
                datas: val,
              });
            }

            PatientDentalAreaData.insertOrUpdate({
              data,
            });
          } else {
            if (DentalAreaDataObj.output.ErrorMessage === "Data Not Found") {
              PatientDentalAreaData.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          DentalAreaDataObj.output = error;
          console.log("DentalAreaData : " + DentalAreaDataObj.output);
        })
        .finally(function() {
          // store.set('systems@SpinnersSTD', false)
          //LOAD DentalAreaDataObj.loadPhamarcyADR(hn, vn);
        });
    },

    loadPhamarcyADR(hn, vn) {
      let data = [];

      // #### Phamarcy ADR Data Load ####
      let ADRObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "PhamarcyADR", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          ADRObj.output = response.data;
          if (ADRObj.output.status === true) {
            PatientPhamarcyADR.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            for (var val of ADRObj.output.result) {
              data.push({
                id: val.adverse_id,
                adverse_id: val.adverse_id,
                hn: val.hn,
                adverse_number: val.adverse_number,
                regdate: val.regdate,
                datas: val,
              });
            }

            PatientPhamarcyADR.insertOrUpdate({
              data,
            });
          } else {
            if (ADRObj.output.ErrorMessage === "Data Not Found") {
              PatientPhamarcyADR.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          ADRObj.output = error;
          console.log("PhamarcyADR : " + ADRObj.output);
        })
        .finally(function() {
          //LOAD ADRObj.loadPhamarcyCounseling(hn, vn);
        });
    },

    loadPhamarcyCounseling(hn, vn) {
      let data = [];

      // #### Phamarcy Counseling Load ####
      let PhamarcyCounselingObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "PhamarcyCounseling", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          PhamarcyCounselingObj.output = response.data;
          if (PhamarcyCounselingObj.output.status === true) {
            PatientPhamarcyCounseling.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            for (var val of PhamarcyCounselingObj.output.result) {
              data.push({
                id: val.drug_counseling_id,
                drug_counseling_id: val.drug_counseling_id,
                hn: val.hn,
                department: val.department,
                regdate: val.regdate,
                datas: val,
              });
            }

            PatientPhamarcyCounseling.insertOrUpdate({
              data,
            });
          } else {
            if (
              PhamarcyCounselingObj.output.ErrorMessage === "Data Not Found"
            ) {
              PatientPhamarcyCounseling.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          PhamarcyCounselingObj.output = error;
          console.log("PhamarcyCounseling : " + PhamarcyCounselingObj.output);
        })
        .finally(function() {
          //LOAD PhamarcyCounselingObj.loadAdmitRightsCenterData(hn, vn);
        });
    },

    loadAdmitRightsCenterData(hn, vn) {
      let DataLoadObj = this;
      let data = [];
      let val = null;

      // #### Admit Rights Center Data Load ####
      this.axios
        .post(this.$store.get("systems@UrlApi") + "AdmitRightsCenterData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            PatientAdmitRightsCenterHead.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            for (val of DataLoadObj.output.result.RightsCenterData
              .emr_ipd_rights_head) {
              data.push({
                id: val.an + val.user_edit + val.emr_ipd_rights_head_status,
                an: val.an,
                hn: val.hn,
                emr_ipd_rights_head_status: val.emr_ipd_rights_head_status,
                datas: val,
              });
            }

            PatientAdmitRightsCenterHead.insertOrUpdate({
              data,
            });
          } else {
            if (DataLoadObj.output.ErrorMessage === "Data Not Found") {
              PatientAdmitRightsCenterHead.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("AdmitRightsCenterData : " + DataLoadObj.output);
        })
        .finally(function() {
          //LOAD DataLoadObj.loadEarHearingDetailData(hn, vn);
          DataLoadObj.AdmitRightsCenterLoadSTD = true;
        });
    },

    loadEarHearingDetailData(hn, vn) {
      let DataLoadObj = this;
      let data = [];
      let val = null;

      // #### Ear Hearing Detail ####
      this.axios
        .post(this.$store.get("systems@UrlApi") + "EarHearingDetail", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            if (vn <= "") {
              PatientEmrEarHearingDetail.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            } else {
              PatientEmrEarHearingDetail.delete({
                where(record) {
                  return record.vn == vn;
                },
              });
            }

            data = [];
            for (val of DataLoadObj.output.result) {
              data.push({
                id: val.ear_hearing_detail_id,
                ear_hearing_detail_id: val.ear_hearing_detail_id,
                ear_hearing_head_id: val.ear_hearing_head_id,
                vn: val.vn,
                hn: val.hn,
                user_edit_datetime: val.user_edit_datetime,
                datas: val,
              });
            }

            PatientEmrEarHearingDetail.insertOrUpdate({
              data,
            });
          } else {
            if (DataLoadObj.output.ErrorMessage === "Data Not Found") {
              if (vn <= "") {
                PatientEmrEarHearingDetail.delete({
                  where(record) {
                    return record.hn == hn;
                  },
                });
              } else {
                PatientEmrEarHearingDetail.delete({
                  where(record) {
                    return record.vn == vn;
                  },
                });
              }
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("EarHearingDetail : " + DataLoadObj.output);
        })
        .finally(function() {
          //LOAD DataLoadObj.loadDisabilityData(hn, vn);
          DataLoadObj.EarHearingDetailLoadSTD = true;
        });
    },

    loadDisabilityData(hn, vn) {
      let DataLoadObj = this;
      let data = [];
      let val = null;

      // #### Emr Disability Data ####
      this.axios
        .post(this.$store.get("systems@UrlApi") + "EmrDisabilityData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            if (vn <= "") {
              PatientEmrDisabilityData.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            } else {
              PatientEmrDisabilityData.delete({
                where(record) {
                  return record.vn == vn;
                },
              });
            }

            data = [];
            for (val of DataLoadObj.output.result) {
              data.push({
                id: val.vn + val.icode,
                icode: val.icode,
                vn: val.vn,
                hn: val.hn,
                datas: val,
              });
            }

            PatientEmrDisabilityData.insertOrUpdate({
              data,
            });
          } else {
            if (DataLoadObj.output.ErrorMessage === "Data Not Found") {
              if (vn <= "") {
                PatientEmrDisabilityData.delete({
                  where(record) {
                    return record.hn == hn;
                  },
                });
              } else {
                PatientEmrDisabilityData.delete({
                  where(record) {
                    return record.vn == vn;
                  },
                });
              }
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("EmrDisabilityData : " + DataLoadObj.output);
        })
        .finally(function() {
          // DataLoadObj.selectVN(hn, vn);
          DataLoadObj.DisabilityLoadSTD = true;
        });
    },

    loadEmrConsultData(hn, vn) {
      let DataLoadObj = this;
      let data = [];
      let val = null;

      // #### Emr Consult Data ####
      this.axios
        .post(this.$store.get("systems@UrlApi") + "EmrConsultData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            if (vn <= "") {
              PatientEmrConsultData.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            } else {
              PatientEmrConsultData.delete({
                where(record) {
                  return record.vn == vn;
                },
              });
            }

            data = [];
            for (val of DataLoadObj.output.result) {
              data.push({
                id: val.vn + val.icode,
                icode: val.icode,
                consult_text: val.name,
                vn: val.vn,
                hn: val.hn,
                datas: val,
              });
            }

            PatientEmrConsultData.insertOrUpdate({
              data,
            });
          } else {
            if (DataLoadObj.output.ErrorMessage === "Data Not Found") {
              if (vn <= "") {
                PatientEmrConsultData.delete({
                  where(record) {
                    return record.hn == hn;
                  },
                });
              } else {
                PatientEmrConsultData.delete({
                  where(record) {
                    return record.vn == vn;
                  },
                });
              }
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("EmrConsultData : " + DataLoadObj.output);
        })
        .finally(function() {
          DataLoadObj.ConsultLoadSTD = true;
        });
    },

    loadOpdHistoryPrintData(hn, vn) {
      let DataLoadObj = this;
      let data = [];
      let val = null;

      // #### Patient Opd History PrintData ####
      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "PatientOpdHistoryPrintData",
          {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
          }
        )
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            PatientOpdHistoryPrintData.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            let dtID = 0;
            for (val of DataLoadObj.output.result) {
              if (
                val.vstdate != "" &&
                val.vstdate != "null" &&
                val.vstdate != null &&
                val.vsttime != "" &&
                val.vsttime != "null" &&
                val.vsttime != null
              ) {
                dtID = DataLoadObj.thaiDatetimeFc.DateTimeId(
                  val.vstdate + " " + val.vsttime
                );
              }

              data.push({
                id: val.loginname + val.vn,
                loginname: val.loginname,
                hn: val.hn,
                vn: val.vn,
                log_datetime: val.log_datetime,
                datas: val,
                visit_orderby: dtID,
              });
            }

            PatientOpdHistoryPrintData.insertOrUpdate({
              data,
            });
          } else {
            if (DataLoadObj.output.ErrorMessage === "Data Not Found") {
              PatientOpdHistoryPrintData.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("PatientOpdHistoryPrintData : " + DataLoadObj.output);
        })
        .finally(function() {
          DataLoadObj.OpdHistoryPrintDataLoadSTD = true;
        });
    },

    selectVN(hn, vn) {
      if (
        hn != "undefined" &&
        hn != undefined &&
        hn != "" &&
        hn != null &&
        hn != "null"
      ) {
        // console.log('QQ33', 'H1', hn, 'H2', this.$route.params.hn, 'V1', vn, 'V2', this.$route.params.vn)

        if (
          vn == "undefined" ||
          vn == undefined ||
          vn == "" ||
          vn == null ||
          vn == "null"
        ) {
          // console.log('QQ22', 'H1', hn, 'H2', this.$route.params.hn, 'V1', vn, 'V2', this.$route.params.vn)

          let DataObj = PatientVisit.query()
            .limit(1)
            .where((record) => record.datas.hn == hn)
            .orderBy("visit_orderby", "desc")
            .get();

          this.ptVN = DataObj[0].datas.vn;
          this.vnS = DataObj[0].datas.vn;

          this.loadVisitOPDVitalSign(hn, DataObj[0].datas.vn);
        } else {
          // console.log('QQ11', 'H1', hn, 'H2', this.$route.params.hn, 'V1', vn, 'V2', this.$route.params.vn)

          //if (this.$route.params.hn != hn && this.$route.params.vn != vn) {
          // this.$router.push({ path: "/PatientEMR/" + hn + "/" + vn });
          this.vnS = vn;
          this.loadVisitOPDVitalSign(hn, vn);
          //}
        }
      }
    },

    loadVisitOPDVitalSign(hn, vn) {
      // #### Vital Sign Data Load ####

      /*
            if((vn == null || vn == '') && hn != null && hn != ""){
                let data = [];

                let VitalSignObj = this;
                this.axios
                .post(this.$store.get("systems@UrlApi") + "VisitOPDVitalSign", {
                CompanyId: this.$store.get("systems@CompanyId"),
                ApiKey: this.$store.get("systems@ApiKey"),
                hn: hn
                })
                .then(function(response) {
                VitalSignObj.output = response.data;
                if (VitalSignObj.output.status === true) {
                    PatientScreening.delete({
                    where(record) {
                        return record.hn == hn;
                    }
                    });

                    data = [];
                    for (var val of VitalSignObj.output.result) {
                    data.push({
                        id: val.vn,
                        vn: val.vn,
                        hn: val.hn,
                        datas: val
                    });
                    }

                    PatientScreening.insertOrUpdate({
                    data
                    });
                }
                })
                .catch(function(error) {
                    VitalSignObj.output = error;
                    console.log("VisitOPDVitalSign : " + VitalSignObj.output);
                })
                .finally(function() {
                    VitalSignObj.VitalSignLoadSTD = true;
                    VitalSignObj.setRouter(hn, vn);
                });

            } else {
                this.VitalSignLoadSTD = true;
                this.setRouter(hn, vn);
            }
            */

      this.VitalSignLoadSTD = true;
      this.setRouter(hn, vn);
    },

    setRouter(hn, vn) {
      if (
        vn != this.$route.params.vn &&
        vn != null &&
        vn != "null" &&
        vn != ""
      ) {
        this.$router.push({ path: "/PatientEMR/" + hn + "/" + vn });
      }

      this.LoadVN = "";

      store.set("systems@vnEMR", vn);

      this.form.hn = hn;
      this.isShow = true;
      this.LoadStd = true;

      store.set("systems@SpinnersShow", false);
    },

    // //////////////////////////////////////////////////////////////////////////////////////////////////////////

    routeChang() {
      if (
        this.$store.get("systems@ApiKey") == "" &&
        this.$store.get("systems@ApiKey") == null
      ) {
        this.ptHN = "";
        this.ptVN = "";
      } else {
        this.ptHN = this.$route.params.hn;
        this.ptVN = this.$route.params.vn;
      }
    },
    handleScroll() {
      let scrollY = window.scrollY;
      let scrollX = window.scrollX;

      if (scrollY >= 20 && this.HGscrollY == false) {
        this.HGscrollY = true;
        // if(this.$store.get('systems@scrollChangColor') != true){
        // store.set('systems@scrollChangColor', true)
        // }
      }

      if (scrollY < 20 && this.HGscrollY == true) {
        this.HGscrollY = false;
        // if(this.$store.get('systems@scrollChangColor') == true){
        // store.set('systems@scrollChangColor', false)
        // }
      }
    },

    PatientActive() {
      let currentObj = this;
      store.set("systems@vnEMR", "");
      store.set("systems@hnEMR", "");
      this.axios
        .post(this.$store.get("systems@UrlApi") + "DoctorVisitActive", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
        })
        .then(function(response) {
          currentObj.output = response.data;
          if (currentObj.output.status === true) {
            // currentObj.form.hn = currentObj.output.result.hn;
            // currentObj.$router.push({ path: '/PatientEMR/'+ currentObj.output.result.hn });
            // document.getElementById('SearchBT').click()

            currentObj.ptCk = true;
            currentObj.vnS = "";

            currentObj.ptHN = currentObj.output.result.hn;
            store.set("systems@hnEMR", currentObj.output.result.hn);
            currentObj.form.hn = currentObj.output.result.hn;
            currentObj.loadPtData(
              currentObj.output.result.hn,
              currentObj.output.result.vn
            );
          } else {
            alert("ไม่พบผู้ป่วยที่แพทย์ตรวจอยู่ในระบบ HOSxP !");
          }
        })
        .catch(function(error) {
          currentObj.output = error;
          console.log("DoctorVisitActive : " + currentObj.output);
        })
        .finally(function() {});
    },

    PTDataLoad(hn) {
      store.set("systems@PTTemplateLast", "");

      let data = [];

      // #### PT Data Load 2 ####
      let PtObjMx = PatientEmrPtData.query()
        .where("hn", hn)
        .orderBy("vn", "desc")
        .limit(1)
        .get();

      if (PtObjMx.length > 0) {
        let PtDataObj2 = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "OpdPtData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: PtObjMx[0].vn,
          })
          .then(function(response) {
            PtDataObj2.output = response.data;
            if (PtDataObj2.output.status === true) {
              PatientEmrPtData.delete({
                where(record) {
                  return record.vn == PtObjMx[0].vn;
                },
              });

              data = [];
              for (var val of PtDataObj2.output.result) {
                data.push({
                  id: val.vn + val.loginname,
                  loginname: val.loginname,
                  vn: val.vn,
                  hn: val.hn,
                  datas: val,
                });
              }

              PatientEmrPtData.insertOrUpdate({
                data,
              });
            } else {
              if (PtDataObj2.output.ErrorMessage === "Data Not Found") {
                PatientEmrPtData.delete({
                  where(record) {
                    return record.vn == PtObjMx[0].vn;
                  },
                });
              }
            }
          })
          .catch(function(error) {
            PtDataObj2.output = error;
            console.log("OpdPtData : " + PtDataObj2.output);
          })
          .finally(function() {
            // #### PT Data Load 2 ####
            let PtObjMx = PatientEmrPtData.query()
              .where("hn", hn)
              .orderBy("vn", "desc")
              .limit(1)
              .get();

            if (PtObjMx.length > 0) {
              // console.log(PtObjMx[0].datas.pt_text)
              store.set("systems@PTTemplateLast", PtObjMx[0].datas.pt_text);
            } else {
              store.set("systems@PTTemplateLast", "");
            }
          });
      }
    },

    loadQueryBTR(hn) {
      let data = [];

      /** LabBtrQueryData */
      let DataObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "LabBtrQueryData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function(response) {
          DataObj.output = response.data;
          if (DataObj.output.status === true) {
            LabBtrData.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            for (var val of DataObj.output.result) {
              data.push({
                id: val.btrMain.btr_id,
                btr_id: val.btrMain.btr_id,
                hn: val.btrMain.hn,
                vn: val.btrMain.vn,
                an: val.btrMain.an,
                ptName:
                  val.btrMain.pname +
                  val.btrMain.fname +
                  " " +
                  val.btrMain.lname,
                transfusion_start_date: val.btrMain.transfusion_start_date,
                transfusion_start_time: val.btrMain.symptom_start_date,
                symptom_start_date: val.btrMain.symptom_start_date,
                symptom_start_time: val.btrMain.symptom_start_time,
                lab_receive_status: val.btrMain.lab_receive_status,
                lab_cross_matching_status:
                  val.btrMain.lab_cross_matching_status,
                btr_status: val.btrMain.btr_status,
                datas: val,
                list_orderby: val.btrMain.list_orderby,
              });
            }

            LabBtrData.insertOrUpdate({
              data,
            });
          } else {
            if (DataObj.output.ErrorMessage === "Data Not Found") {
              LabBtrData.delete({
                where(record) {
                  return record.hn == hn;
                },
              });
            }
          }
        })
        .catch(function(error) {
          DataObj.output = error;
          console.log("LabBtrData : " + DataObj.output);
        })
        .finally(function() {
          DataObj.BTRloadStatus = true;
        });
    },

    loadDataOnCreate() {
      let data = [];

      // #### Webbase URL Load ####
      let WebbaseObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "WebbaseUrl", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
        })
        .then(function(response) {
          WebbaseObj.output = response.data;
          if (WebbaseObj.output.status === true) {
            data = [];
            for (var val of WebbaseObj.output.result) {
              data.push({
                id: val.web_id,
                web_id: val.web_id,
                web_name: val.web_name,
                web_host: val.web_host,
                datas: val,
              });
            }

            PatientWebbaseUrl.insertOrUpdate({
              data,
            });
          } else {
            // console.log('WebbaseUrl : '+WebbaseObj.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          WebbaseObj.output = error;
          console.log("WebbaseUrl : " + WebbaseObj.output);
        });

      // #### api emr template ####
      let ObjEmrTemplate = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "EmrTemplate", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
        })
        .then(function(response) {
          ObjEmrTemplate.output = response.data;

          if (ObjEmrTemplate.output.status === true) {
            PatientEmrTemplate.delete({
              where(record) {
                return record.id != "";
              },
            });

            data = [];
            for (var val of ObjEmrTemplate.output.result) {
              data.push({
                id: val.emr_template_id,
                emr_template_id: val.emr_template_id,
                emr_template_type: val.emr_template_type,
                emr_template_status: val.emr_template_status,
                datas: val,
              });
            }

            PatientEmrTemplate.insertOrUpdate({
              data,
            });
          } else {
            // console.log('DocumentScan : '+ScrObjDc.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          ObjEmrTemplate.output = error;
          console.log("EmrTemplate : " + ObjEmrTemplate.output);
        });

      // #### Pt Template Load ####
      let PatientEmrPtTemplateObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "EmrPtTemplate", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
        })
        .then(function(response) {
          PatientEmrPtTemplateObj.output = response.data;
          if (PatientEmrPtTemplateObj.output.status === true) {
            PatientEmrPtTemplate.delete({
              where(record) {
                return record.id != "";
              },
            });

            data = [];
            for (var val of PatientEmrPtTemplateObj.output.result) {
              data.push({
                id: val.pt_template_id,
                pt_template_id: val.pt_template_id,
                pt_template_name: val.pt_template_name,
                pt_template_status: val.pt_template_status,
                datas: val,
              });
            }

            PatientEmrPtTemplate.insertOrUpdate({
              data,
            });
          } else {
            // console.log('PatientEmrPtTemplate : '+FastTrackStemiObj.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          PatientEmrPtTemplateObj.output = error;
          console.log(
            "PatientEmrPtTemplate : " + PatientEmrPtTemplateObj.output
          );
        });

      // #### Pt IndicatorsObj Load ####
      let ptIndicatorsObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "EmrPtIndicator", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
        })
        .then(function(response) {
          ptIndicatorsObj.output = response.data;
          if (ptIndicatorsObj.output.status === true) {
            PatientEmrPtIndicator.delete({
              where(record) {
                return record.id != "";
              },
            });

            data = [];
            for (var val of ptIndicatorsObj.output.result) {
              data.push({
                id: val.pt_indicators_id,
                pt_indicators_id: val.pt_indicators_id,
                pt_indicators_type: val.pt_indicators_type,
                pt_indicators_status: val.pt_indicators_status,
                datas: val,
                pt_indicators_orderby: val.pt_indicators_orderby,
              });
            }

            PatientEmrPtIndicator.insertOrUpdate({
              data,
            });
          } else {
            // console.log('EmrPtIndicator : '+ptIndicatorsObj.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          ptIndicatorsObj.output = error;
          console.log("EmrPtIndicator : " + ptIndicatorsObj.output);
        });

      // #### Admit Discharge TypeData Load ####
      let DataLoadObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "AdmitDischargeTypeData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
        })
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            PatientAdmitDischargeType.delete({
              where(record) {
                return record.id != "";
              },
            });

            data = [];
            for (var val of DataLoadObj.output.result) {
              data.push({
                id: val.dchtype,
                dchtype: val.dchtype,
                name: val.name,
                datas: val,
              });
            }

            PatientAdmitDischargeType.insertOrUpdate({
              data,
            });
          } else {
            // console.log('AdmitDischargeTypeData : '+DataLoadObj.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("AdmitDischargeTypeData : " + DataLoadObj.output);
        });

      // #### Admit Discharge Status Data Load ####
      this.axios
        .post(this.$store.get("systems@UrlApi") + "AdmitDischargeStatusData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
        })
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            PatientAdmitDischargeStatus.delete({
              where(record) {
                return record.id != "";
              },
            });

            data = [];
            for (var val of DataLoadObj.output.result) {
              data.push({
                id: val.dchstts,
                dchstts: val.dchstts,
                name: val.name,
                datas: val,
              });
            }

            PatientAdmitDischargeStatus.insertOrUpdate({
              data,
            });
          } else {
            // console.log('AdmitDischargeStatusData : '+DataLoadObj.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("AdmitDischargeStatusData : " + DataLoadObj.output);
        });

      // #### Lab Btr Choice Data Load ####
      this.axios
        .post(this.$store.get("systems@UrlApi") + "LabBtrChoice", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
        })
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            LabBtrChoice.delete({
              where(record) {
                return record.id != "";
              },
            });

            data = [];
            for (var val of DataLoadObj.output.result) {
              data.push({
                id: val.btr_choice_id,
                btr_choice_id: val.btr_choice_id,
                btr_choice_name: val.btr_choice_name,
                btr_choice_other: val.btr_choice_other,
                btr_choice_status: val.btr_choice_status,
                datas: val,
                list_orderby: val.btr_choice_order,
              });
            }

            LabBtrChoice.insertOrUpdate({
              data,
            });
          } else {
            // console.log('AdmitDischargeStatusData : '+DataLoadObj.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("LabBtrChoice : " + DataLoadObj.output);
        });

      // #### Admit Rights Center Choice Data Load ####
      this.axios
        .post(this.$store.get("systems@UrlApi") + "AdmitRightsCenterChoice", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
        })
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            PatientAdmitRightsCenterChoice.delete({
              where(record) {
                return record.id != "";
              },
            });

            data = [];
            for (var val of DataLoadObj.output.result.RightsCenterChoice
              .emr_ipd_rights) {
              data.push({
                id: val.emr_ipd_rights_id,
                emr_ipd_rights_id: val.emr_ipd_rights_id,
                emr_ipd_rights_status: val.emr_ipd_rights_status,
                datas: val,
              });
            }

            PatientAdmitRightsCenterChoice.insertOrUpdate({
              data,
            });

            PatientAdmitRightsCenterChoiceL1.delete({
              where(record) {
                return record.id != "";
              },
            });

            data = [];
            for (var val2 of DataLoadObj.output.result.RightsCenterChoice
              .emr_ipd_rights_level1) {
              data.push({
                id: val2.emr_ipd_rights_level1_id,
                emr_ipd_rights_level1_id: val2.emr_ipd_rights_level1_id,
                emr_ipd_rights_id: val2.emr_ipd_rights_id,
                emr_ipd_rights_level1_status: val2.emr_ipd_rights_level1_status,
                datas: val2,
              });
            }

            PatientAdmitRightsCenterChoiceL1.insertOrUpdate({
              data,
            });

            PatientAdmitRightsCenterChoiceL2.delete({
              where(record) {
                return record.id != "";
              },
            });

            data = [];
            for (var val3 of DataLoadObj.output.result.RightsCenterChoice
              .emr_ipd_rights_level2) {
              data.push({
                id: val3.emr_ipd_rights_level2_id,
                emr_ipd_rights_level2_id: val3.emr_ipd_rights_level2_id,
                emr_ipd_rights_id: val3.emr_ipd_rights_id,
                emr_ipd_rights_level2_status: val3.emr_ipd_rights_level2_status,
                datas: val3,
              });
            }

            PatientAdmitRightsCenterChoiceL2.insertOrUpdate({
              data,
            });
          } else {
            // console.log('AdmitRightsCenterChoice : '+DataLoadObj.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("AdmitRightsCenterChoice : " + DataLoadObj.output);
        });

      // #### Narcotic Load ####
      let Narcotic = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "DrugNarcotic", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
        })
        .then(function(response) {
          Narcotic.output = response.data;
          if (Narcotic.output.status === true) {
            data = [];
            for (var val of Narcotic.output.result) {
              data.push({
                id: val.icode,
                icode: val.icode,
                narcotic_type: val.narcotic_type,
                name: val.name,
                item_satus: val.item_satus,
                datas: val,
              });
            }

            DrugNarcotic.insertOrUpdate({
              data,
            });
          } else {
            // console.log('Narcotic : '+Narcotic.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          Narcotic.output = error;
          console.log("Narcotic : " + Narcotic.output);
        });
    },
    getPatientData(hn) {
      if (this.form.hn == hn) {
        let Obj5 = PatientData.query()
          .where((record) => record.datas.hn == hn)
          .get();

        this.PatientDataSTD = true;

        return Obj5[0];
      } else {
        this.PatientDataSTD = false;

        return null;
      }
    },
    getPatientMDRData(hn) {
      if (hn != "" && hn != null && hn != "null") {
        let Obj5 = PatientMDRData.query()
          .where((record) => record.datas.hn == hn)
          .get();

        this.PatientMDRDataSTD = true;
      } else {
        this.PatientMDRDataSTD = false;
      }
    },
    addBTR() {
      document.getElementById("bt-btr-add").click();
    },
  },
})
export default class PatientEMR extends Vue {}
</script>

<style lang="scss">
.icon-custom1 {
  margin-top: -2px;
  width: 20px;
}

.icon-custom2 {
  width: 14px;
}

.bd-group-custom1 {
  padding: 1.5rem;
  margin-right: 0;
  margin-left: 0;
  border-width: 0.5rem;
  padding: 1rem;
  margin: 1rem -15px 0;
  border: solid #f8f9fa;
  // border-width: .2rem 0 0;
  max-width: 1200px;
  margin: auto;
  text-align: left;
  margin-top: 20px !important;
  border-color: #41b883 !important;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.bd-group-custom2 {
  padding: 1.5rem;
  margin-right: 0;
  margin-left: 0;
  border-width: 0.5rem;
  padding: 1rem;
  margin: 1rem -15px 0;
  border: solid #f8f9fa;
  // border-width: .2rem 0 0;
  max-width: 1200px;
  margin: auto;
  text-align: left;
  margin-top: 20px !important;
  border-color: #17a2b8 !important;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.bd-group-custom3 {
  padding: 1.5rem;
  margin-right: 0;
  margin-left: 0;
  border-width: 0.5rem;
  padding: 1rem;
  margin: 1rem -15px 0;
  border: solid #f8f9fa;
  // border-width: .2rem 0 0;
  max-width: 1200px;
  margin: auto;
  text-align: left;
  margin-top: 20px !important;
  border-color: #fff3a0 !important;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.padding-2px {
  padding: 2px !important;
}
</style>
